import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class PuntearTransactionEffectsCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(transaction_ids:string[], effect_ids:string[], mode:string|null): Promise<any> {
    let args: any = { 
      transaction_ids: transaction_ids,
      effect_ids: effect_ids,
      action: 'puntear'
    }
    if (mode) {
      args['mode'] = mode
    }
    this.frontend.puntearLoading = true;    
    let res = await this.dispatcher.dispatch('puntear.transaction', args);
    const outputs = Array.isArray(res.output) ? res.output : (res.output ? [res.output] : []);
    for (const out of outputs) {
      if (out && out.id) {
        for (let i in this.frontend.transactions_list) {
          if (this.frontend.transactions_list[i].id == out.id) {
            this.frontend.transactions_list[i].contrapartida = out.contrapartida
            this.frontend.transactions_list[i].default_contrapartida = out.default_contrapartida;
            this.frontend.transactions_list[i].contains_effects = out.contains_effects;
          }
        }
      }
    }
    this.frontend.puntearLoading = false;
  }
}